import { ContentService } from '@blk/cwp-ng-framework';
import { ColumnExtractor, ErrorData, ErrorDataOptions } from '@ddt-web/data-service';

import { FactResult } from '../../models/fact-result.model';

export class FactExtractor {
	constructor(public dataExtractors: ColumnExtractor[], public dataTransformSignature: Function) { }
	public extract(storeData: { [storeName: string]: any }, contentService?: ContentService): FactResult {
		try {
			const dataPoints = [];
			this.dataExtractors.forEach(extractor => {
				const dataPoint = extractor.extractor()(storeData);
				if (!dataPoint && dataPoint !== 0) { throw new Error(`${(<any>extractor).expression || ''} data point does not exist`); }
				dataPoints.push(dataPoint);
			});
			const result = this.dataTransformSignature(...dataPoints, contentService);
			return new FactResult(result);
		} catch (error) {
			return new FactResult(
				null,
				ErrorData.create({
					id: 'FACT_EXTRACTOR_ERROR',
					success: false,
					allDataReturned: false,
					errorCodes: ['FACT_MAPPING_ERROR'],
					failureReason: 'Error occurred during extracting of fact',
					debugMessage: (<Error>error).message
				} as ErrorDataOptions)
			);
		}
	}
}
